import React from "react";
import "./Footer.css";
import NetflixLogo from "../media/NetflixLogo.png";

const Footer = () => {
  return (
    <div>
      <div className="footer-bs">
        <div className="row">
          <div className="row-box">
            <div className="pages">
              <ul>
                <li>
                  <a href="/">Audio and Subtitles</a>
                </li>
                <li>
                  <a href="/">Media Center</a>
                </li>
                <li>
                  <a href="/">Privacy</a>
                </li>
                <li>
                  <a href="/">Contact Us</a>
                </li>
              </ul>
            </div>
            <div className="pages">
              <ul>
                <li>
                  <a href="/">Audio Descriptions</a>
                </li>
                <li>
                  <a href="/">Investor Relations</a>
                </li>
                <li>
                  <a href="/">Legal Notices</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="row-box">
            <div className="pages">
              <ul>
                <li>
                  <a href="/">Help Center</a>
                </li>
                <li>
                  <a href="/">Jobs</a>
                </li>
                <li>
                  <a href="/">Cookie Preference</a>
                </li>
              </ul>
            </div>
            <div className="pages">
              <ul>
                <li>
                  <a href="/">Gift Card</a>
                </li>
                <li>
                  <a href="/">Terms of Use</a>
                </li>
                <li>
                  <a href="/">Corporate Information</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <p>© 1997-2022 Netflix, Inc. "{"a4661bb3-21ca-4ec8-95ce-67bb06dc8e3e"}"</p> */}
    </div>
  );
};

export default Footer;
